<template>
  <div class="container-fluid py-4 px-4">


    <div class="col-12 d-flex justify-content-end">
        <div class="input-group buscar-estiloCuadrado" style="max-width: 350px;">
          <span class="input-group-text buscar-estiloCuadrado">
            <i class="bi bi-search"></i>
          </span>
          <input class="form-control buscar-estiloCuadrado" type="text" placeholder="Nombre" v-model="filterField"
          @input="filtro" />
        </div>
      </div>


    <div class="table-responsive mx-2 mt-2 py-3">
      <table class="table table-bordered">
        <thead class="reducirTamaño">
          <tr class="bg-solimano text-white text-center">
            <th>ID</th>
            <th>NOMBRE</th>
            <th>CREACIÓN</th>
            <th>ACTUALIZACIÓN</th>
            <th><i class="bi bi-boxes fs-5"></i></th>
          </tr>
        </thead>

        <tbody class="text-center texto-fini align-middle">


          <tr v-if="loading">
            <td colspan="5" class="text-center" style="height: 220px;">
              <div class="d-flex flex-column align-items-center justify-content-center h-100">
                <div class="spinner-border text-warning" style="width: 3rem; height: 3rem;"></div>
                <div class="mt-3 text-secondary fw-semibold fs-6">
                  Filtrando información...
                </div>
              </div>
            </td>
          </tr>

          <!-- DATOS -->
          <tr v-else v-for="lista in paginatedLista" :key="lista.idModulo" class="reducirTamaño">
            <td>{{ lista.idModulo }}</td>
            <td class="text-start">{{ lista.nomModulo }}</td>
            <td>{{ lista.audfechaCreacion }}</td>
            <td>{{ lista.audfechaActualizacion }}</td>

            <td class="py-1">

              <button @click="openEditModal(lista.idModulo, lista.nomModulo, lista.nomIcono, lista.idIcono)"
                class="btn btn-warning btn-sm mx-1">
                <i class="bi bi-pencil text-white fs-6"></i>
              </button>

              <button @click="Cambiar(lista.idModulo)" class="btn btn-light btn-sm"
                :class="lista.estado ? 'text-danger' : 'text-success'">
                <i :class="lista.estado ? 'bi bi-toggle-off' : 'bi bi-toggle-on'" class="fs-6"></i>
              </button>

            </td>
          </tr>
        </tbody>
      </table>
    </div>


    <div class="pagination-container d-flex justify-content-center align-items-center gap-2 my-3">

   
      <button class="btn btn-outline-primary btn-sm" @click="currentPage = 1" :disabled="currentPage === 1">
        <i class="bi bi-chevron-double-left"></i>
      </button>

    
      <button class="btn btn-outline-primary btn-sm" @click="currentPage--" :disabled="currentPage === 1">
        <i class="bi bi-chevron-left"></i>
      </button>

   
      <span class="pagination-info small">
        Página {{ currentPage }} de {{ totalPages }}
      </span>

   
      <button class="btn btn-outline-primary btn-sm" @click="currentPage++" :disabled="currentPage === totalPages">
        <i class="bi bi-chevron-right"></i>
      </button>

  
      <button class="btn btn-outline-primary btn-sm" @click="currentPage = totalPages"
        :disabled="currentPage === totalPages">
        <i class="bi bi-chevron-double-right"></i>
      </button>

    </div>


    <b-modal ref="editModal" centered title="Editar Módulo" hide-footer hide-close-button
      dialog-class="modal-md-custom">
      
      <div class="container-fluid">

    
        <div class="row g-2 mb-3">
          <div v-for="icon in icons" :key="icon.nomIcono"
            class="col-2 icon-box d-flex align-items-center justify-content-center"
            @click="selectIcon(icon.nomIcono, icon.idIcono)" :class="{ selected: icon.nomIcono === selectedIcon }">
            <i :class="icon.nomIcono" class="fs-4"></i>
          </div>
        </div>

     
        <p class="fw-semibold mb-3">
          Icono seleccionado: <i :class="selectedIcon" class="fs-4"></i>
        </p>

    
        <div>
          <label class="form-label">Nombre del Módulo:</label>
          <input type="text" v-model="editedIconName" class="form-control" />
        </div>

     
        <div class="text-end mt-4">
          <b-button variant="primary" class="me-2" @click="saveChanges">Guardar</b-button>
          <b-button variant="secondary" @click="closeEditModal">Cerrar</b-button>
        </div>

      </div>
    </b-modal>


  </div>
</template>

<script>
import Swal from "sweetalert";
import { mapGetters, mapActions } from "vuex";
export default {
  name: "PowerbyTablaModulo",

  data() {
    return {
      currentPage: 1,
      itemsPerPage: 10,
      loading: false,
      filterField: "",
      selectedIcon: "ninguno",
      icons: [],
      idIcono: "",
      editedIconName: ""
    };
  },

  mounted() {
    this.idUsuario = localStorage.getItem("userId");
    this.axios.get(`BIClientes/ListadoIconos`).then((r) => {
      console.log(r.data);
      this.icons = r.data;
    });
  },

  computed: {

    ...mapGetters('acciones', ['ListaModulos']),


    filteredList() {
      const filtro = (this.filterField || '').toLowerCase().trim();
      if (!filtro) return this.ListaModulos || [];

      return (this.ListaModulos || []).filter(item =>
        String(item.nomModulo).toLowerCase().includes(filtro)
      );
    },

    totalPages() {
      return Math.ceil(this.filteredList.length / this.itemsPerPage);
    },


    startIndex() {
      return (this.currentPage - 1) * this.itemsPerPage;
    },


    paginatedLista() {

      const start = (this.currentPage - 1) * this.itemsPerPage;
      return this.filteredList.slice(start, start + this.itemsPerPage);
    },


  },

  created() {
  },

  methods: {
    ...mapActions('acciones', ['ListarModulo']),

    Cambiar(idModulo) {
      this.axios
        .put(`BIClientes/ModificarEstadoModulo?idModulo=${idModulo}`)
        .then((r) => {
          console.log(r.data);
          this.ListarModulo();
        });
    },
    openEditModal(idModulo, nombre, Icono, idIcono) {
      console.log(Icono, nombre, idModulo);
      this.idModulo = idModulo;
      this.editedIconName = nombre;
      this.selectedIcon = Icono;
      this.idIcono = idIcono;
      this.$refs.editModal.show();
    },

    closeEditModal() {
      this.idModulo = "";
      this.editedIconName = "";
      this.idIcono = "";

      this.$refs.editModal.hide();
    },
    saveChanges() {
      // Aquí puedes guardar el nombre editado y realizar otras operaciones necesarias
      // Luego, cierra el modal
      const from = {
        idUsuario: this.idUsuario,
        idIcono: this.idIcono,
        idModulo: this.idModulo,
        nomModulo: this.editedIconName,
      };

      console.log(from);
      this.axios.put(`BIClientes/ModificarModulo`, from).then((r) => {
        console.log(r.data);

        this.ListarModulo();
        Swal(`Se realizo los cambios`, "", "success");
        this.selectedIcon = "";
      });
      this.closeEditModal();
    },
    changePage(page) {
      this.currentPage = page;
    },

    selectIcon(iconClass, id) {
      this.selectedIcon = iconClass;
      this.idIcono = id;
    },
    filtro() {
      this.loading = true;
      setTimeout(() => {
        this.currentPage = 1;
        this.loading = false;
      }, 900);

    },
  },
};
</script>

<style scoped>
/* Modal ligeramente más grande */
.modal-md-custom .modal-dialog {
  max-width: 550px !important;
}

/* Caja del icono (más pequeña) */
.icon-box {
  border: 1px solid #e3e3e3;
  padding: 6px;
  /* ↓ antes era 9px */
  border-radius: 8px;
  /* ↓ antes 10px */
  cursor: pointer;
  background: #f8f9fa;
  transition: all 0.2s ease;
  width: 45px;
  /* ↓ tamaño controlado */
  height: 45px;
  /* ↓ tamaño controlado */
  display: flex;
  justify-content: center;
  align-items: center;
}

/* Icono interno más pequeño */
.icon-box i {
  font-size: 0.9rem !important;
  /* ↓ antes era fs-7 (~1rem) */
}

/* Hover */
.icon-box:hover {
  background: #e9ecef;
  transform: scale(1.05);
}

/* Seleccionado */
.icon-box.selected {
  border: 2px solid #0d6efd;
  background: #e7f1ff;
  transform: scale(1.07);
}


.b-modal .modal-header button.close {
  display: none;
}

.bg-solimano {
  text-align: center;
  background: #0080c8;
}

strong {
  font-size: 1.64rem;
  color: black;
}

.letra {
  font-weight: 600;
}

/* .icon-selector {
  display: flex;
  gap: 10px;
} */
.bg-iconos {
  background: #f7f7f7;
}

.icon-selector div {
  cursor: pointer;
  border: 1px solid #ccc;
  border-radius: 5px;
  padding: 2px;
}

.icon-selector div.selected {
  border-color: #007bff;
  /* Color de borde al seleccionar */
}

.icon-selector i {
  font-size: 24px;
  /* Tamaño de los iconos */
}

.tamañoLetra {
  font-size: 0.8rem;
}

.reducirTamaño {
  font-size: 0.65rem;
}
</style>
